"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceholderSlide = exports.Title = exports.PageIndicator = exports.PageIndicatorContainer = exports.RowContainer = exports.CarouselContainer = exports.Row = exports.Slide = exports.RightButton = exports.LeftButton = exports.RightButtonContainer = exports.LeftButtonContainer = exports.CarouselPaginationButtonMixin = exports.CarouselCore = void 0;
const forEach_1 = __importDefault(require("lodash/forEach"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const isString_1 = __importDefault(require("lodash/isString"));
const styled_components_1 = __importStar(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const placeholderSlideBorderRadius = '10px';
const placeholderSlideColor = '#E6E6E6';
const slidesPerPage = (responsiveSlidesPerPage, styles) => {
    if ((0, isNumber_1.default)(responsiveSlidesPerPage)) {
        return styles(responsiveSlidesPerPage);
    }
    const breakpoints = {};
    (0, forEach_1.default)(responsiveSlidesPerPage, (v, k) => {
        breakpoints[k] = styles(v);
    });
    return (0, monera_app_core_1.MediaBreakpointMixin)(breakpoints);
};
exports.CarouselCore = styled_components_1.default.div `
  width: 100%;
  position: relative;
  ${(props) => {
    let style = props.hidden ? 'visibility: hidden;' : '';
    if (!(0, isNil_1.default)(props.width)) {
        style = `${style} width:${props.width}`;
    }
    return style;
}}
`;
exports.CarouselPaginationButtonMixin = (0, styled_components_1.css) `
  background: #e7e9ec;
  border-radius: 3px;
  border-color: #adb1b8 #a2a6ac #8d9096;
  border-style: solid;
  border-width: 1px;
  text-decoration: none;
  cursor: pointer;
  z-index: 1;
  margin: auto 0;
  width: 40px;
  height: 40px;
  color: #231f20;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.14);
  align-items: center;
  justify-content: center;
  display: flex;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  text-transform: none;
  overflow: visible;
`;
exports.LeftButtonContainer = styled_components_1.default.div `
  left: ${(props) => props.leftPaginationButtonDistance};
  z-index: 1;
  cursor: pointer;
  position: absolute;
  align-items: center;
  justify-content: center;
  display: flex;
  overflow: visible;
`;
exports.RightButtonContainer = styled_components_1.default.div `
  right: ${(props) => props.rightPaginationButtonDistance};
  z-index: 1;
  cursor: pointer;
  position: absolute;
  align-items: center;
  justify-content: center;
  display: flex;
  overflow: visible;
`;
exports.LeftButton = styled_components_1.default.button `
  &:before {
    content: '❮';
  }
  ${exports.CarouselPaginationButtonMixin}
`;
exports.RightButton = styled_components_1.default.button `
  &:before {
    content: '❯';
  }
  ${exports.CarouselPaginationButtonMixin}
`;
const calculateWidth = (props) => {
    const { slides, imageMargins = '', carouselWidth = undefined } = props;
    if ((0, isString_1.default)(carouselWidth) &&
        (0, isString_1.default)(imageMargins) &&
        carouselWidth.slice(-2) === 'px' &&
        imageMargins.slice(-2) === 'px') {
        return `${(parseInt(carouselWidth, 10) - (slides - 1) * parseInt(imageMargins, 10)) / slides}px`;
    }
    return `${100 / slides}%`;
};
exports.Slide = styled_components_1.default.div `
  ${(props) => {
    var _a;
    return props.useAutoSlideWidth &&
        slidesPerPage((_a = props.slidesPerPage) !== null && _a !== void 0 ? _a : 5, (slides) => (0, styled_components_1.css) `
        flex: 0 0 ${calculateWidth(Object.assign({ slides }, props))};
        width: ${calculateWidth(Object.assign({ slides }, props))};
      `);
}}
  width: 'auto'
  min-height: 1px;
  margin: 0;
  height: 'auto';
  position: relative;
  box-sizing: border-box;
  display: flex;
  ${(props) => (props.index !== 0 ? `margin-left: ${props.imageMargins};` : 'margin-left: 0px;')}
  ${(props) => (props.showFocusElement ? 'cursor: pointer;' : '')}
  ${({ allowSnap }) => (allowSnap ? 'scroll-snap-align: start;' : null)}
`;
exports.Row = styled_components_1.default.div `
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
`;
exports.CarouselContainer = styled_components_1.default.div `
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  box-sizing: border-box;
  text-align: center;
  position: relative;
`;
exports.RowContainer = styled_components_1.default.div `
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  box-sizing: border-box;
  text-align: center;
  position: relative;
  scroll-snap-type: x mandatory;
  ${({ allowScrolling }) => {
    return (0, styled_components_1.css) `
      overflow-x: ${allowScrolling ? 'scroll' : 'auto'};
      ::-webkit-scrollbar {
        width: 0px;
        background: transparent;
        height: 0px;
      }
      scrollbar-width: none;
      -ms-overflow-style: none;
    `;
}}
`;
exports.PageIndicatorContainer = styled_components_1.default.ol `
  position: absolute;
  right: 0;
  bottom: 10px;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
`;
exports.PageIndicator = styled_components_1.default.li `
  position: relative;
  flex: 0 1 auto;
  width: 8px;
  height: 8px;
  margin-right: 3px;
  margin-left: 3px;
  border-radius: 50%;
  border-color: #adb1b8 #a2a6ac #8d9096;
  border-style: solid;
  border-width: 1px;
  text-indent: -999px;
  ${(props) => (props.clickable ? 'cursor: pointer;' : '')}
  ${(props) => (props.active ? 'background-color: #808080;' : 'background-color: red')}
  &:before {
    position: absolute;
    top: -10px;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 10px;
    content: '';
  }
  &:after {
    position: absolute;
    bottom: -10px;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 10px;
    content: '';
  }
  list-style-type: none;
`;
exports.Title = styled_components_1.default.h2 `
  display: block;
  width: auto;
  float: left;
  font-size: 21px;
  line-height: 1.5 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  padding-bottom: 0;
  color: #444 !important;
`;
exports.PlaceholderSlide = styled_components_1.default.div `
  min-height: 112px;
  height: 100%;
  background-color: ${placeholderSlideColor};
  border-radius: ${placeholderSlideBorderRadius};
`;
